// src/pages/ResourceDetail.js

import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { categories } from '../data/resources';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';

const ResourceDetail = () => {
  const { slug } = useParams();
  const [markdown, setMarkdown] = useState('Loading content...');

  // ✅ Combine all resources across categories
  const allResources = categories.flatMap((cat) => cat.resources);
  const resource = allResources.find((r) => r.slug === slug);
  // 🪵 Add logs to debug:
  console.log('🟡 URL param slug:', slug);
  console.log('🟢 Matched resource:', resource);
  useEffect(() => {
    if (resource?.slug) {
      fetch(`/content/resources/${resource.slug}.md`)
        .then((res) => res.text())
        .then(setMarkdown)
        .catch(() => setMarkdown('🚫 Error loading content.'));
    }
  }, [resource]);

  if (!resource) {
    return (
      <section className="section-wrapper bg-white text-center">
        <h2 className="section-title">Resource Not Found</h2>
        <Link
          to="/resources"
          className="text-blue-600 underline"
        >
          Back to Resource Center
        </Link>
      </section>
    );
  }

  return (
    <section className="section-wrapper bg-white">
      <div className="max-w-4xl mx-auto">
        <h2 className="text-3xl font-bold text-primary mb-4">
          {resource.title}
        </h2>
        <img
          src={resource.image}
          alt={resource.title}
          className="w-full h-48 object-cover rounded mb-6"
        />
        <div className="prose prose-lg max-w-none text-gray-800">
          <ReactMarkdown remarkPlugins={[remarkGfm]}>{markdown}</ReactMarkdown>
        </div>

        <div className="mt-6">
          <Link
            to="/resources"
            className="text-sunshine-yellow font-semibold hover:text-warm-orange"
          >
            ← Back to Resource Center
          </Link>
        </div>
      </div>
    </section>
  );
};

export default ResourceDetail;
